<template lang="html">
  <section class="col center middle" style="height: 100vh;">
    <img src="logo_outline.svg" alt="">
    <div class="col center middle" style="background: radial-gradient(white, transparent);">
      <b class="c-primary">Carsten Jacobsen</b>
      <h1>Designer & Coder</h1>
      <channels></channels>
    </div>
  </section>
</template>

<script>
import Channels from './channels.vue';

export default {
  components: {
    Channels
  }
}
</script>

<style scoped lang="scss">

  h1{
    font-size: calc(25px + (70 - 25) * ((100vw - 300px) / (1600 - 300)));
  }

  section{
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  img{
    width: 40px;
    position: absolute;
    top: 30px;
    left: 30px;
  }


</style>
